import {Component, OnInit} from '@angular/core';
import {trigger, transition, style, animate} from '@angular/animations';
import {AppConstants} from 'src/app/shared/constants/app-constant';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-exam-result',
    templateUrl: './exam-result.component.html',
    styleUrls: ['./exam-result.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({opacity: 0, transform: 'translateY(-15px)'}),
                animate(
                    '500ms cubic-bezier(0.25, 0.8, 0.25, 1)',
                    style({opacity: 1, transform: 'translateY(0)'})
                ),
            ]),
            transition(':leave', [
                animate(
                    '400ms cubic-bezier(0.4, 0, 0.2, 1)',
                    style({opacity: 0, transform: 'translateY(-15px)'})
                ),
            ]),
        ]),
    ],
})
export class ExamResultComponent implements OnInit {
    pageTitle: string;
    hasAnnualReport = false; // or true, based on availability
    hasSystemGrading = false; // or true, based on availability

    constructor(
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.route.data.subscribe(data => {
            this.pageTitle = data.title;
        });
    }

    activeIndex: number | null = null;
    schools = AppConstants.schools;

    examResultSections = [];
    academicCalendarList = [];
    curriculumList = [];

    examScheduleSections = [

    ];



    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }
}
